
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class OrderShippingDialog extends Serenity.EntityDialog<OrderShippingRow, any> {
        protected getFormKey() { return OrderShippingForm.formKey; }
        protected getIdProperty() { return OrderShippingRow.idProperty; }
        protected getLocalTextPrefix() { return OrderShippingRow.localTextPrefix; }
        protected getNameProperty() { return OrderShippingRow.nameProperty; }
        protected getService() { return OrderShippingService.baseUrl; }
        protected getDeletePermission() { return OrderShippingRow.deletePermission; }
        protected getInsertPermission() { return OrderShippingRow.insertPermission; }
        protected getUpdatePermission() { return OrderShippingRow.updatePermission; }

        protected form = new OrderShippingForm(this.idPrefix);

    }
}